import type { AppThunk } from "store/store";

import { investProfileSliceActions } from "./reducer";

const ENTRANCE_SURVEY_KEY = "entranceSurveyPage";

const readEntranceSurveyePageThunk = (): AppThunk => (dispatch) => {
  const entranceSurveyePage = localStorage.getItem(ENTRANCE_SURVEY_KEY);
  dispatch(
    investProfileSliceActions.setEntranceSurveyePage(
      entranceSurveyePage !== null ? entranceSurveyePage : ""
    )
  );
};

const saveEntranceSurveyePageThunk =
  (entranceSurveyePage: string): AppThunk =>
  (dispatch) => {
    localStorage.setItem(ENTRANCE_SURVEY_KEY, entranceSurveyePage);
    dispatch(
      investProfileSliceActions.setEntranceSurveyePage(
        entranceSurveyePage !== null ? entranceSurveyePage : ""
      )
    );
  };

const clearEntranceSurveyePageThunk = (): AppThunk => (dispatch) => {
  localStorage.removeItem(ENTRANCE_SURVEY_KEY);
  dispatch(investProfileSliceActions.setEntranceSurveyePage(""));
};

export const investProfileThunks = {
  readEntranceSurveyePageThunk,
  saveEntranceSurveyePageThunk,
  clearEntranceSurveyePageThunk,
};
